import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Dashboard from './pages/Dashboard';
import Engineers from './pages/Engineers';
import Projects from './pages/Projects';
import Matching from './pages/Matching';
import Settings from './pages/Settings';
import EngineerDetail from './pages/EngineerDetail';
import ProjectDetail from './pages/ProjectDetail';

function AppContent() {
  const location = useLocation();

  return (
    <ErrorBoundary location={location}>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/engineers" element={<Engineers />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/matching" element={<Matching />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/engineer/:id" element={<EngineerDetail />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
        </Routes>
      </Layout>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;